import { render, staticRenderFns } from "./CommonLink.vue?vue&type=template&id=2199c907&"
import script from "./CommonLink.vue?vue&type=script&lang=js&"
export * from "./CommonLink.vue?vue&type=script&lang=js&"
import style0 from "./CommonLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports